import { Box, FormHelperText, TextField, Typography } from "@mui/material";

import { htmlContentStyles } from "@/utils/htmlContentStyle";
import { renderMathInHtml } from "@/utils/mathRenderer";

import ResizableRichTextEditor from "./ResizableRichTextEditor";

interface EditingFieldProps {
  label: string;
  value: string;
  onChange?: (value: string) => void;
  type?: "text" | "textarea";
  placeholder?: string;
  rows?: number;
  isEditing?: boolean;
  error?: boolean;
  helperText?: string;
  hideMenuBar?: boolean;
  initialHeight?: number;
  labelVariant?: "subtitle1" | "text14B" | "text14M" | "text14R" | "text13B" | "text13M" | "text13R" | "text13L";
}

const EditingField = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  isEditing = true,
  error,
  helperText,
  hideMenuBar = false,
  initialHeight = 200,
  labelVariant = "subtitle1",
}: EditingFieldProps) => {
  return (
    <Box>
      <Typography variant={labelVariant}>{label}:</Typography>
      {isEditing ? (
        type === "textarea" ? (
          <ResizableRichTextEditor
            value={value}
            onChange={(value) => onChange?.(value)}
            placeholder={placeholder}
            initialHeight={initialHeight}
            hideMenuBar={hideMenuBar}
          />
        ) : (
          <TextField
            fullWidth
            size="small"
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            placeholder={placeholder}
            error={error}
            variant="outlined"
            sx={{
              mt: 0.5,
              "& .MuiInputBase-input": {
                fontSize: 14,
              },
            }}
          />
        )
      ) : (
        <Typography
          variant="text13L"
          dangerouslySetInnerHTML={{ __html: renderMathInHtml(value) }}
          sx={{
            width: "100%",
            ...htmlContentStyles,
          }}
        />
      )}
      {error && helperText && (
        <FormHelperText error>{helperText}</FormHelperText>
      )}
    </Box>
  );
};

export default EditingField;
